import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SessionUser } from 'src/shared/session';

import { REOPEN_PETITION_ERROR_MAP } from '../constants';

import type { ReopenPetitionV2Mutation, ReopenPetitionV2MutationVariables } from './reopenPetition.graphql';
import { ReopenPetitionV2 } from './reopenPetition.graphql';

export async function reopenPetition(
	{ id, user }: { id: string; user?: SessionUser },
	{ gql: { fetch }, errorReporter }: UtilityContext,
) {
	if (!user) {
		throw new Error(REOPEN_PETITION_ERROR_MAP.UNAUTHENTICATED_ERROR);
	}

	const { data, requestId } = await fetch<ReopenPetitionV2Mutation, ReopenPetitionV2MutationVariables>({
		query: ReopenPetitionV2,
		variables: {
			input: { petitionId: id },
		},
		rejectOnError: true,
	});

	if (!data.reopenPetition.success) {
		// could be authentication error or status code of 400, 401, 403, 404
		const err = new Error(REOPEN_PETITION_ERROR_MAP.UNKNOWN_ERROR);
		void errorReporter.report({
			error: new Error('Failed to reopen petition'),
			context: {
				reason: REOPEN_PETITION_ERROR_MAP.UNKNOWN_ERROR,
				requestId,
			},
		});
		throw err;
	}

	return { status: 'ok' as const };
}
